// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mobile-shortcut"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 19V22H5V2H19V5M12 18H12.0039V18.0039H12V18Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M16.0571 13.0567L15.7058 12.3509L15 11.9996L15.7058 11.6483L16.0571 10.9426L16.4084 11.6483L17.1141 11.9996L16.4084 12.3509L16.0571 13.0567Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M21.1052 8.39062L21.1403 8.46114L21.2108 8.49624L21.1403 8.53134L21.1052 8.60185L21.0701 8.53134L20.9996 8.49624L21.0701 8.46114L21.1052 8.39062Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M21.1052 15.4004L21.1403 15.4709L21.2108 15.506L21.1403 15.5411L21.1052 15.6116L21.0701 15.5411L20.9996 15.506L21.0701 15.4709L21.1052 15.4004Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const MobileShortcutIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-shortcut',
    ref,
    icon: element,
  },
));

MobileShortcutIcon.displayName = 'MobileShortcutIcon';

export default MobileShortcutIcon;
